import get from 'lodash/get';
import set from 'lodash/set';
export function getLocaleMap() {
  var space = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'current';
  return get(globalThis, "__GLOBAL_STRING_FORMAT__.default.strings.".concat(space), {});
}
export function setLocaleMap(locales) {
  var space = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'current';
  return set(globalThis, "__GLOBAL_STRING_FORMAT__.default.strings.".concat(space), locales);
}